/**
 * Technology & Digital Reach Translations Module (French)
 * 
 * Contains: Website Analytics, Social Media, LEADER Magazine, Technology Trends
 * 
 * @module technology
 * @language fr
 */

export const technology = {
  technologyFuture: {
    pageTitle: "Technologie et Portée Numérique",
    pageSubtitle: "JCI.cc • Réseaux Sociaux • Magazine LEADER | 260K+ abonnés, 70+ pays"
  },
  technologyRole: {
    title: "Rôle de la Technologie",
    subtitle: "Comment JCI utilise la technologie pour connecter et autonomiser les jeunes leaders",
    new: "NOUVEAU"
  },
  programs: {
    jciWebsite: "Site Web JCI.cc",
    website: "Site Web",
    socialMedia: "Réseaux Sociaux",
    social: "Social",
    leaderMagazine: "Magazine LEADER",
    magazine: "Magazine",
    activeUsers: "Utilisateurs Actifs",
    pageViews: "Pages Vues",
    avgSession: "Session Moyenne",
    bounceRate: "Taux de Rebond",
    returnVisitors: "Visiteurs Récurrents",
    mobileAccess: "accès via mobile",
    mobileFirstApproach: "Approche mobile-first essentielle",
    deviceBreakdown: "Répartition par Appareil",
    trafficSources: "Sources de Trafic",
    topGeographicSources: "Principales Sources Géographiques",
    largest: "Plus Grand",
    topPagesVisited: "Pages les Plus Visitées",
    combinedFollowers: "Abonnés Combinés",
    monthlyImpressions: "Impressions Mensuelles",
    organicGrowth: "Croissance Organique",
    avgEngagement: "Engagement Moyen",
    followers: "Abonnés",
    topContent: "Contenu Principal",
    topVideo: "Vidéo Principale",
    views: "vues",
    retention: "rétention",
    totalReaders: "Lecteurs Totaux",
    bookVisits: "Visites du Livre",
    avgReadTime: "Temps de Lecture Moyen",
    countries: "Pays",
    keyInsight: "Aperçu Clé",
    readersPerIssue: "Lecteurs par Numéro (7 Numéros, Jan-Oct 2025)",
    readTimeTrend: "Tendance du Temps de Lecture (Engagement Croissant)",
    deviceAccess: "Accès par Appareil",
    regionalReach: "Portée Régionale",
    contentThemes: "Thèmes de Contenu",
    devices: {
      desktopLaptop: "Ordinateur/Laptop",
      mobilePhone: "Téléphone Mobile",
      tablet: "Tablette"
    },
    trafficSourceTypes: {
      organicSearch: "Recherche Organique",
      direct: "Direct",
      referral: "Référence",
      paid: "Payant",
      goodSeoVisibility: "Bonne visibilité SEO",
      strongBrandRecognition: "Forte reconnaissance de marque",
      socialPartnerships: "Social + partenariats",
      limitedCampaigns: "Campagnes limitées"
    },
    topPagesData: {
      aboutJci: "À Propos de JCI",
      newsEvents: "Actualités et Événements",
      whatWeDo: "Ce Que Nous Faisons",
      programsPage: "Programmes",
      getInvolved: "Participez",
      discoveringOrg: "Personnes découvrant l'org",
      engagementSeeking: "Recherche d'engagement",
      programInterest: "Intérêt pour les programmes",
      actionOriented: "Visiteurs orientés action",
      ctaMomentum: "Momentum d'appel à l'action"
    }
  },
  socialMediaData: {
    communityHub: "Centre Communautaire",
    visualStorytelling: "Narration Visuelle",
    thoughtLeadership: "Leadership d'Opinion",
    longFormContent: "Contenu Long Format",
    fastestGrowth: "Croissance la Plus Rapide",
    consistentGrowth: "Croissance Constante",
    eventHighlights: "Faits saillants d'événements",
    memberStories: "Histoires de membres",
    campaigns: "Campagnes",
    reels: "Reels (3x engagement)",
    visualStories: "Histoires visuelles",
    leadershipInsights: "Insights de leadership",
    partnerships: "Partenariats",
    trainingSessions: "Sessions de formation",
    reach: "portée",
    engagement: "engagement",
    impressions: "impressions",
    interactions: "interactions",
    watchTime: "temps de visionnage",
    whatIsJci: "Qu'est-ce que JCI?"
  },
  futureSkills: {
    communicationPublicSpeaking: "Communication et Prise de Parole",
    communicationDesc: "Essentiel pour le leadership et l'influence",
    criticalThinking: "Pensée Critique et Résolution de Problèmes",
    criticalThinkingDesc: "Compétences analytiques pour défis complexes",
    conflictResolution: "Résolution de Conflits et Négociation",
    conflictResolutionDesc: "Gérer les disputes et construire le consensus",
    projectManagement: "Gestion de Projet",
    projectManagementDesc: "Planifier et exécuter des initiatives efficacement",
    digitalTechLiteracy: "Littératie Numérique et Technologique",
    digitalTechDesc: "Comprendre les outils technologiques modernes",
    financialLiteracy: "Littératie Financière",
    financialLiteracyDesc: "Gestion des budgets et planification financière",
    interculturalCommunication: "Communication Interculturelle",
    interculturalDesc: "Travailler efficacement entre les cultures",
    advocacyInfluence: "Plaidoyer et Influence",
    advocacyDesc: "Conduire le changement par la persuasion"
  },
  technology: {
    title: "Technologie et Avenir",
    subtitle: "Adoption technologique et tendances d'innovation future",
    memberProfile: "Profil Technologique du Membre",
    engagementMembers: "Engagement des Membres",
    aiInLeadership: "IA dans le Leadership",
    transformative: "Transformateur",
    aiDescription: "Les outils IA pour la prise de décision, l'apprentissage personnalisé et l'automatisation transforment la façon dont les jeunes leaders se développent et dirigent.",
    digitalFirstSkills: "Compétences Numériques d'Abord",
    critical: "Critique",
    digitalDescription: "La littératie des données, le marketing numérique, la programmation et la cybersécurité sont désormais des compétences essentielles pour l'avancement professionnel.",
    sustainabilityGreenTech: "Durabilité et Tech Verte",
    essential: "Essentiel",
    sustainabilityDescription: "Tech climatique, énergie renouvelable et solutions d'économie circulaire favorisant la durabilité environnementale.",
    mentalHealthTech: "Tech de Santé Mentale",
    growing: "Croissant",
    mentalHealthDescription: "Apps de bien-être mental, plateformes de télétérapie et chatbots IA fournissant un soutien accessible en santé mentale.",
    keyFocusAreas: "Domaines d'Intérêt Clés",
    source: "Source",
    trendsResearchSources: "Sources de Recherche sur les Tendances",
    futureSkillsPriorities: "Priorités des Compétences Futures 2025",
    futureSkillsSubtitle: "Compétences essentielles identifiées par les membres JCI pour le développement du leadership et la réussite professionnelle",
    priority: "Priorité",
    skillsDevelopmentFramework: "Cadre de Développement des Compétences",
    skillsFrameworkDesc: "Ces priorités guident les programmes de formation, ateliers et initiatives de développement du leadership de JCI. Les membres ont identifié ces compétences comme les plus critiques pour naviguer les défis évolutifs de 2025 et au-delà, avec un accent particulier sur la communication, la pensée critique et la littératie numérique.",
    veryHigh: "Très Haute",
    high: "Haute",
    medium: "Moyenne",
    mediumHigh: "Moyenne-Haute",
    emerging: "Émergent",
    // Focus area items
    aiAugmentedDecisionMaking: "Prise de décision augmentée par l'IA",
    personalizedLearningPaths: "Parcours d'apprentissage personnalisés",
    automatedAnalytics: "Analytique automatisée",
    ethicalAIGovernance: "Gouvernance éthique de l'IA",
    dataLiteracy: "Littératie des données",
    digitalMarketing: "Marketing numérique",
    programmingBasics: "Bases de programmation",
    cybersecurityAwareness: "Sensibilisation à la cybersécurité",
    climateTechnology: "Technologie climatique",
    renewableEnergy: "Énergie renouvelable",
    circularEconomy: "Économie circulaire",
    esgMeasurement: "Mesure ESG",
    wellnessApplications: "Applications de bien-être",
    teletherapyPlatforms: "Plateformes de télétérapie",
    aiSupportChatbots: "Chatbots IA de soutien",
    stressManagementTools: "Outils de gestion du stress"
  }
} as const;
